<template>
  <MobialisCard>
    <slot></slot>
    <div class="d-flex">
      <div class>
        <div class="gradeBox">
          <div v-if="creditGrade != null">
            <div data-cy="creditGrade" class="creditGrade">
              {{ creditGrade }}
            </div>
            <div class="creditGradeText">{{ creditGradeText }}</div>
          </div>
          <div v-else>
            <div class="creditGrade">
              <div class="iconHolder">
                <img data-cy="errorIcon" src="../../assets/error-icon.svg" alt="error icon" />
              </div>
            </div>
            <div
              class="row justify-content-center font-weight-bold creditGradeText"
              v-html-safe="$t('message.credit.notFound')"
            ></div>
          </div>
        </div>
      </div>
      <div class>
        <ul class="pl-4 mb-0">
          <li
            :class="{ userScore: creditGrade === 'A' }"
            v-html-safe="
              `A ${gradeRanges.A.lowerBound} - ${gradeRanges.A.upperBound} ${$t('message.credit.categories.gradeA')}`
            "
          ></li>
          <li
            :class="{ userScore: creditGrade === 'B' }"
            v-html-safe="
              `B ${gradeRanges.B.lowerBound} - ${gradeRanges.B.upperBound} ${$t('message.credit.categories.gradeB')}`
            "
          ></li>
          <li
            :class="{ userScore: creditGrade === 'C' }"
            v-html-safe="
              `C ${gradeRanges.C.lowerBound} - ${gradeRanges.C.upperBound} ${$t('message.credit.categories.gradeC')}`
            "
          ></li>
          <li
            :class="{ userScore: creditGrade === 'D' }"
            v-html-safe="
              `D ${gradeRanges.D.lowerBound} - ${gradeRanges.D.upperBound} ${$t('message.credit.categories.gradeD')}`
            "
          ></li>
          <li
            :class="{ userScore: creditGrade === 'E' }"
            v-html-safe="
              `E ${gradeRanges.E.lowerBound} - ${gradeRanges.E.upperBound} ${$t('message.credit.categories.gradeE')}`
            "
          ></li>
        </ul>
      </div>
    </div>
    <p v-if="creditGrade != null && !isByZipCode">
      {{ $t('message.credit.700CreditInfo') }}
    </p>
    <p v-else>{{ $t('message.credit.scoreNotAvailable') }}</p>
    <slot name="bottomSlot"></slot>
  </MobialisCard>
</template>

<script>
export default {
  name: 'usScoreCard',
  props: {
    creditGrade: {
      type: String,
      required: false,
      validator: creditGrade => ['A', 'B', 'C', 'D', 'E'].indexOf(creditGrade) > -1,
    },
    isByZipCode: {
      type: Boolean,
      required: false,
      default: false,
    },
    gradeRanges: {
      type: Object,
      required: true,
      default() {
        switch (this.bureau) {
          case 'EXP':
            return {
              A: { lowerBound: 800, upperBound: 850 },
              B: { lowerBound: 740, upperBound: 799 },
              C: { lowerBound: 670, upperBound: 739 },
              D: { lowerBound: 580, upperBound: 669 },
              E: { lowerBound: 300, upperBound: 579 },
            };
          case 'EFX':
            return {
              A: { lowerBound: 800, upperBound: 850 },
              B: { lowerBound: 740, upperBound: 799 },
              C: { lowerBound: 670, upperBound: 739 },
              D: { lowerBound: 580, upperBound: 669 },
              E: { lowerBound: 280, upperBound: 579 },
            };
          default:
            return {
              A: { lowerBound: 781, upperBound: 850 },
              B: { lowerBound: 720, upperBound: 780 },
              C: { lowerBound: 658, upperBound: 719 },
              D: { lowerBound: 601, upperBound: 657 },
              E: { lowerBound: 300, upperBound: 600 },
            };
        }
      },
    },
    bureau: {
      type: String,
      required: true,
      default: 'TU',
    },
  },
  computed: {
    creditGradeText() {
      switch (this.creditGrade) {
        case 'A':
          return 'Super Prime';
        case 'B':
          return 'Prime Plus';
        case 'C':
          return 'Prime';
        case 'D':
          return 'Near Prime';
        case 'E':
          return 'Sub Prime';
        default:
          return null;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@import '../../assets/scss/variables';

ul {
  list-style-type: none;
}
li {
  font-size: 12px;
  color: rgb(75, 88, 99);
  margin-bottom: 3px;
  &.userScore {
    color: $primary;
    font-weight: bold;
  }
}
p {
  font-size: 14px;
  color: rgb(75, 88, 99);
  margin-top: 20px;
  margin-bottom: 5px;
}
.gradeBox {
  height: 100px;
  background: #f0f4f7;
  border-radius: 6px;
  text-align: center;
  width: 100px;
}

.creditGrade {
  font-size: 3.5rem;
  font-weight: bold;
  color: rgb(0, 118, 206);

  .iconHolder {
    img {
      width: 40px;
      height: 40px;
      vertical-align: unset;
    }
  }
}
.creditGradeText {
  line-height: 0;
  font-size: 14px;
  font-weight: bold;
}
@media screen and (min-width: 576px) {
  .gradeBox {
    width: 279px;
    text-align: unset;
  }
  .creditGrade {
    padding-left: 50px;
    padding-top: 10px;

    .iconHolder {
      padding-top: 5px;
      img {
        width: 50px;
        height: 50px;
      }
    }
  }
  .creditGradeText {
    position: absolute;
    left: 150px;
    top: 72px;
    font-size: 20px;
  }
}
//hack to detect when app is running on IE11
@media screen and (-ms-high-contrast: active), (-ms-high-contrast: none) {
  .creditGrade {
    width: 10px;
  }
}
</style>
